import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  Divider,
  RadioGroup,
  Radio,
  Input,
  Box 
} from "@chakra-ui/react";

import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { fetchAsyncCheckInvoiceExist } from "redux/salesInvoice";
import { useToasts } from "react-toast-notifications";


const InvoiceNumberSetting = ({ isOpen, onClose,moduleId,invPrefix,handleInvoiceSetting}) => {
  const [invoiceMode, setInvoiceMode] = useState("auto");
  const [nextNumber, setNextNumber] = useState("");
  const dispatch = useDispatch();
  const {addToast} = useToasts();
  
  const checkInvoiceNumberIsExist = async () => {
    try {
      const res = await dispatch(fetchAsyncCheckInvoiceExist({
        moduleId:moduleId,
        invNo:nextNumber
      }));
      return res?.payload?.isExist ?? false; 
    } catch (err) {
      addToast("error fetching invoice number!", { appearance: "error" });
      return false; 
    }
  };

  const handleSave = async(e) => {
    e.preventDefault()
    const isExist = await checkInvoiceNumberIsExist();
    if (isExist) {
      addToast("This Invoice number is already created!", { appearance: "error" });
      return;
    }
    handleInvoiceSetting({
      nextNumber,
      invoiceMode
    })
    onClose();
  };
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          top="0"
          maxH="fit-content"
          margin="0 auto"
          bottom="0"
          className="payment-terms-modal"
        >
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              <h6 className="module-heading" style={{ fontSize: "16px" }}>
                Configure Invoice Number Preferences
              </h6>
            </ModalHeader>
            <ModalCloseButton />
          </div>
          <ModalBody className="mt-4 p-3" minW="320px" maxW="100%">
            <Text h={4} fontWeight={600}>
              Associated Series
            </Text>
            <Text>Default Invoice Series</Text>
            <Divider mt={2} />
            <Text fontSize="12px" className="mt-2" color="gray">
              Your invoice numbers are set on auto-generate mode to save your
              time. <br />
              Are you sure about changing this setting?
            </Text>
            <Box fontSize="12px">
              <RadioGroup onChange={setInvoiceMode} value={invoiceMode} mt={4}>
                <Radio fontSize="12px" value="auto">
                <span style={{fontSize:'12px'}}>Continue auto-generating invoice numbers</span>
                </Radio>
              </RadioGroup>
              {invoiceMode === "auto" &&
              <Row className="mx-1">
                <Col className="col-4">
                  <Text mt={1}>Prefix:</Text>
                  <Input
                    value={invPrefix?.prfx}
                    disabled
                    fontSize="12px"
                    mt={1}
                  />
                </Col>
                <Col className="col-8">
                  <Text mt={1}>Next Number:</Text>
                  <Input
                    value={nextNumber}
                    fontSize="12px"
                    type="number"
                    onChange={(e) => setNextNumber(e.target.value)}
                    placeholder="0000"
                    mt={1}
                  />
                </Col>
              </Row>
              }

              <RadioGroup onChange={setInvoiceMode} value={invoiceMode} mt={1}>
                <Radio value="manual"> <span style={{fontSize:'12px'}}>Enter invoice numbers manually</span></Radio>
              </RadioGroup>
              {invoiceMode === "manual" &&
              <Row className="mx-1">
                <Col className="col-4">
                  <Text mt={1}>Prefix:</Text>
                  <Input
                   value={invPrefix?.prfx}
                   disabled
                   fontSize="12px"
                    mt={1}
                  />
                </Col>
                <Col className="col-8">
                  <Text mt={1}>Invoice Number:</Text>
                  <Input
                    value={nextNumber}
                    fontSize="12px"
                    type="number"
                    onChange={(e) => setNextNumber(e.target.value)}
                    placeholder="0000"
                    mt={1}
                  />
                </Col>
              </Row>
              }
            </Box>
          </ModalBody>

          <ModalFooter className="setting-module-footer pt-2" style={{borderTop:'1px solid #f0f0f0'}}>
            <Button
              onClick={(e) => handleSave(e)}
              className="btn save-btn btn"
              mr={3}
              disabled={!invoiceMode || !nextNumber || nextNumber === 0 }
            >
              Save
            </Button>
            <Button onClick={onClose} className="btn">
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default InvoiceNumberSetting;
